export default __webpack_public_path__ + "static/header-ea7fceb839afeac8273232de72765bc0.png";